import { z } from 'zod';
/**
 * Asking for help, and being answered.
 *
 * The same shapes serve both sides: a customer's own threads and the operator
 * queue are the same rows read by different people, and a second set of types
 * for the panel would be a second place to add a field.
 */
const ticketStatusSchema = z.enum(['open', 'answered', 'closed']);
/** Not exported: both lists below are built from it, and nothing else needs it. */
const ticketSchema = z.object({
    id: z.string(),
    orgId: z.string(),
    /** Shown in the operator queue; the customer already knows whose it is. */
    organisation: z.string(),
    subject: z.string(),
    status: ticketStatusSchema,
    createdAt: z.iso.datetime(),
    /** Moved by every message, so a list can order by what changed last. */
    updatedAt: z.iso.datetime(),
    messageCount: z.number().int(),
});
export const ticketListSchema = z.object({ tickets: z.array(ticketSchema) });
export const ticketThreadSchema = z.object({
    ticket: ticketSchema,
    messages: z.array(z.object({
        id: z.string(),
        /** Which side wrote it. The screens render the two differently. */
        side: z.enum(['customer', 'operator']),
        author: z.string(),
        body: z.string(),
        at: z.iso.datetime(),
    })),
});
/**
 * Opening a thread.
 *
 * A subject and a body, both required. A ticket with no body is a subject
 * line somebody has to chase, which costs the exchange this exists to save.
 */
export const openTicketRequestSchema = z.object({
    subject: z.string().trim().min(1, 'a ticket needs a subject').max(200),
    body: z.string().trim().min(1, 'say what is happening').max(10_000),
});
export const replyTicketRequestSchema = z.object({
    body: z.string().trim().min(1, 'a reply needs something in it').max(10_000),
});
//# sourceMappingURL=support.js.map